<ng-container *ngIf="firstFeature">
        <mat-list role="list">
            <ng-container *ngFor="let property of propArray">
                    <mat-list-item role="listitem">
                        <span mat-line><b>{{property.key}}:</b></span>
                        <span mat-line> {{property.value}} </span>
                    </mat-list-item>
            </ng-container>
        </mat-list>
</ng-container>